import React, {Component} from "react";
import "./AllCustomersSearch.css";
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../../configuration";

class AllCustomersSearch extends Component {

    saveByteArray = (reportName, byte) => {
        // let bytes = new Uint8Array(byte);
        let blob = new Blob([byte], {type: "data:text/csv;charset=utf-8;"});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let fileName = reportName;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    exportCustomersToCsv = () => {
        let fileDate = new Date();
        let editMinutes = fileDate.getMinutes();
        if(editMinutes<10) {
            editMinutes = "0"+editMinutes;
        }
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/admin/customers/export-customers', axiosConfig )
            .then((res) => {
                // let sales = this.base64ToArrayBuffer(res.data);
                this.saveByteArray("Customer_list_"+fileDate.getFullYear()+("0" + (fileDate.getMonth() + 1)).slice(-2)+("0" + fileDate.getDate()).slice(-2)
                    +fileDate.getHours()+editMinutes+".csv", res.data);

            })
            .catch((err) => {
                console.log("[API] ERROR: cvs data  ", err);
            });
    };

    render() {
        return (
            <div className="row">
                <div className="col-md-8 search-div customers-search-mobi">
                            <span className="search-text">
                                <FormattedMessage id="app.all-customers-search.search"
                                                  defaultMessage="Search Text:"/>
                            </span>&nbsp;&nbsp;&nbsp;&nbsp;<input className="search-field" type="text" onChange={this.props.handleSearchOnChange}/>
                </div>
                <div className="col-md-4 pull-left no-padding-left search-div pull-right ">
                            <button className="search-btn btn-warning" onClick={this.exportCustomersToCsv}>
                                顧客一覧ダウンロード
                            </button>
                </div>
            </div>
        )
    }
}
export default AllCustomersSearch;



// WEBPACK FOOTER //
// ./src/components/Admin/AllCustomers/AllCustomersSearch/AllCustomersSearch.js